import { useEffect, useRef } from 'react';
import './style.css';

const DURATION = 30000;
const DECLINED_DURATION = 5000;

// Shown to the requestee: accept or decline
export const FriendRequestToast = ({ from, onAccept, onDecline, onClose }) => {
    const timerRef = useRef(null);

    useEffect(() => {
        timerRef.current = setTimeout(onClose, DURATION);
        return () => clearTimeout(timerRef.current);
    }, [onClose]);

    return (
        <div className="fr-toast">
            <button className="fr-toast__close" onClick={onClose} aria-label="Close">×</button>
            <p className="fr-toast__text">
                <strong>{from}</strong> wants to be friends!
            </p>
            <div className="fr-toast__actions">
                <button className="fr-toast__btn fr-toast__btn--accept" onClick={onAccept}>Accept</button>
                <button className="fr-toast__btn fr-toast__btn--decline" onClick={onDecline}>Decline</button>
            </div>
            <div className="fr-toast__bar-track">
                <div className="fr-toast__bar" style={{ animationDuration: `${DURATION}ms` }} />
            </div>
        </div>
    );
};

// Shown to the requester when their request was accepted
export const FriendAcceptedToast = ({ by, onClose }) => {
    useEffect(() => {
        const t = setTimeout(onClose, DURATION);
        return () => clearTimeout(t);
    }, [onClose]);

    return (
        <div className="fr-toast fr-toast--accepted">
            <button className="fr-toast__close" onClick={onClose} aria-label="Close">×</button>
            <p className="fr-toast__text">
                <strong>{by}</strong> accepted your friend request!
            </p>
            <div className="fr-toast__bar-track">
                <div className="fr-toast__bar" style={{ animationDuration: `${DURATION}ms` }} />
            </div>
        </div>
    );
};

// Format seconds into a display label (e.g. 300 → "5 min")
const formatTC = (secs) => `${Math.round(secs / 60)} min`;

// Shown when someone challenges you to a game
export const ChallengeToast = ({ from, timeControl, onAccept, onDecline, onClose }) => {
    const timerRef = useRef(null);

    useEffect(() => {
        timerRef.current = setTimeout(onClose, DURATION);
        return () => clearTimeout(timerRef.current);
    }, [onClose]);

    return (
        <div className="fr-toast fr-toast--challenge">
            <button className="fr-toast__close" onClick={onClose} aria-label="Close">×</button>
            <p className="fr-toast__text">
                <strong>{from}</strong> challenged you to a {formatTC(timeControl)} game!
            </p>
            <div className="fr-toast__actions">
                <button className="fr-toast__btn fr-toast__btn--accept" onClick={onAccept}>Accept</button>
                <button className="fr-toast__btn fr-toast__btn--decline" onClick={onDecline}>Decline</button>
            </div>
            <div className="fr-toast__bar-track">
                <div className="fr-toast__bar" style={{ animationDuration: `${DURATION}ms` }} />
            </div>
        </div>
    );
};

// Shown to the challenger when there was an error sending the challenge
export const ChallengeErrorToast = ({ message, onClose }) => {
    useEffect(() => {
        const t = setTimeout(onClose, DECLINED_DURATION);
        return () => clearTimeout(t);
    }, [onClose]);

    return (
        <div className="fr-toast fr-toast--error">
            <button className="fr-toast__close" onClick={onClose} aria-label="Close">×</button>
            <p className="fr-toast__text">{message || 'Could not send challenge.'}</p>
            <div className="fr-toast__bar-track">
                <div className="fr-toast__bar" style={{ animationDuration: `${DECLINED_DURATION}ms` }} />
            </div>
        </div>
    );
};

// Shown to the challenger when their challenge was declined
export const ChallengeDeclinedToast = ({ by, onClose }) => {
    useEffect(() => {
        const t = setTimeout(onClose, DECLINED_DURATION);
        return () => clearTimeout(t);
    }, [onClose]);

    return (
        <div className="fr-toast">
            <button className="fr-toast__close" onClick={onClose} aria-label="Close">×</button>
            <p className="fr-toast__text">
                <strong>{by}</strong> declined your challenge.
            </p>
            <div className="fr-toast__bar-track">
                <div className="fr-toast__bar" style={{ animationDuration: `${DECLINED_DURATION}ms` }} />
            </div>
        </div>
    );
};
